/* Produktseiten-Design – aus der freigegebenen Autodata-Vorlage herausgelöst (21.09.2026).
   Gilt global für Produktseiten; Quelle war der Block custom_liquid_reviews_css. */
(function () {
  function start() {
    var liste = [].slice.call(document.querySelectorAll('.media-gallery .media-viewer__item img.product-image'));
    if (!liste.length || document.querySelector('.adx-lb')) return;
    // Adresse erst beim Anzeigen ermitteln – Bilder 2..n laden verzögert (src anfangs leer)
    function adresse(i) {
      var s = i.getAttribute('data-src') || i.getAttribute('src') || '';
      if (!s || s.indexOf('data:') === 0) { s = (i.getAttribute('data-srcset') || i.getAttribute('srcset') || '').split(',').pop().trim().split(' ')[0] || i.currentSrc || ''; }
      return s.replace(/([?&])width=\d+/, '$1width=1800');
    }
    var urls = liste.map(function () { return ''; });
    var ic = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + d + '</svg>'; };
    var lb = document.createElement('div');
    lb.className = 'adx-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
    lb.innerHTML = '<img class="adx-lb__img" alt="">' +
      '<button class="adx-lb__btn adx-lb__close" type="button" aria-label="Schließen">' + ic('<path d="M18 6 6 18M6 6l12 12"/>') + '</button>' +
      '<button class="adx-lb__btn adx-lb__prev" type="button" aria-label="Vorheriges Bild">' + ic('<path d="m15 18-6-6 6-6"/>') + '</button>' +
      '<button class="adx-lb__btn adx-lb__next" type="button" aria-label="Nächstes Bild">' + ic('<path d="m9 18 6-6-6-6"/>') + '</button>' +
      '<span class="adx-lb__count"></span>';
    document.body.appendChild(lb);
    var bild = lb.querySelector('.adx-lb__img'), zahl = lb.querySelector('.adx-lb__count'), pos = 0;
    function zeige(n) { pos = (n + urls.length) % urls.length; bild.src = adresse(liste[pos]); bild.alt = liste[pos].alt || ''; zahl.textContent = (pos + 1) + ' / ' + urls.length; }
    function auf(n) { zeige(n); lb.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
    function zu() { lb.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
    liste.forEach(function (img, n) {
      var ziel = img.closest('a') || img;
      ziel.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); auf(n); }, true);
    });
    lb.querySelector('.adx-lb__close').addEventListener('click', zu);
    lb.querySelector('.adx-lb__prev').addEventListener('click', function (e) { e.stopPropagation(); zeige(pos - 1); });
    lb.querySelector('.adx-lb__next').addEventListener('click', function (e) { e.stopPropagation(); zeige(pos + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) zu(); });
    document.addEventListener('keydown', function (e) { if (!lb.classList.contains('is-open')) return; if (e.key === 'Escape') zu(); if (e.key === 'ArrowLeft') zeige(pos - 1); if (e.key === 'ArrowRight') zeige(pos + 1); });
    var x0 = null;
    lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) { if (x0 === null) return; var d = e.changedTouches[0].clientX - x0; if (Math.abs(d) > 50) zeige(pos + (d < 0 ? 1 : -1)); x0 = null; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
/* Brotkrümel vollständig: fehlt die Kategorie (Direktaufruf), „Autodata“ ergänzen (19.09.2026) */
(function () {
  function krumen() {
    var ol = document.querySelector('.product-breadcrumbs .breadcrumbs-list');
    if (!ol || ol.querySelector('a[href*="/collections/"]') || ol.children.length !== 2) return;
    var erste = ol.children[0], li = erste.cloneNode(true), a = li.querySelector('a');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var k = window.ADX_KRUME || {}; if (!k.handle) return;
    a.href = root + 'collections/' + k.handle; a.textContent = k.titel; a.removeAttribute('aria-current');
    erste.insertAdjacentElement('afterend', li);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', krumen); else krumen();
})();
/* Beratungskasten unter die Vorteile-Kacheln, damit die Kauf-Buttons zusammenstehen (19.09.2026) */
(function () {
  function umsetzen() {
    var box = document.querySelector('.product-info .adf-beratungs-box'), ziel = document.querySelector('.product-info .adx-benefits');
    if (box && ziel && ziel.nextElementSibling !== box) { ziel.insertAdjacentElement('afterend', box); box.style.marginTop = '12px'; }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', umsetzen); else umsetzen();
})();
